const sendQuizCompleted = async (setIsQuizCompleted: SetBoolean) => {
  const response = await fetch(
    "https://yda-wedding.com/api/set_quiz_completed",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ is_quiz_completed: true }),
      credentials: "include",
    },
  );

  if (response.ok) {
    setIsQuizCompleted(true);
  }
};

export default sendQuizCompleted;
